import React from 'react';
import styled from 'styled-components';
import { Button, ButtonPrimary, DialogCentreScreen, DialogFullScreen } from '@yuhu-inc/yuhui';
import MediaQuery from 'react-responsive';

import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const StyledNoButton = styled(Button)`
  background: none;
  border: none;
  font-weight: bold;
  color: ${AccentColor()};
  @media (max-width: 768px) {
    margin-top: 24px;
  }
`;

const StyledContainer = styled.div`
  max-width: 560px;
  @media (max-width: 768px) {
    height: 90vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

const StyledButtonContainer = styled.div`
  display: flex;
  margin-top: 32px;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const YES = 'yes';
const NO = 'no';

export const DialogForConfirmation = ({
  handleConfirmation,
  children,
  noKey,
  yesKey,
  ...dialog
}) => {
  const handleClick = (e) => {
    e.preventDefault();
    handleConfirmation(e.target.dataset.confirmation === YES);
    dialog.hide();
  };

  return (
    <React.Fragment>
      <MediaQuery query="(max-device-width: 750px)">
        <DialogFullScreen
          label={getTranslatedString('landlordPortal.rules.deleteConfirmationLabel')}
          style={{ backgroundColor: '#fff' }}
          {...dialog}
        >
          <StyledContainer>
            {children}
            <StyledButtonContainer>
              <ButtonPrimary data-confirmation={YES} onClick={handleClick} contentKey={yesKey} />
              <StyledNoButton data-confirmation={NO} onClick={handleClick} contentKey={noKey} />
            </StyledButtonContainer>
          </StyledContainer>
        </DialogFullScreen>
      </MediaQuery>
      <MediaQuery query="(min-device-width: 751px)">
        <DialogCentreScreen
          label={getTranslatedString('landlordPortal.rules.deleteConfirmationLabel')}
          style={{ zIndex: 9999 }}
          {...dialog}
        >
          <StyledContainer>
            {children}
            <StyledButtonContainer>
              <StyledNoButton data-confirmation={NO} onClick={handleClick} contentKey={noKey} />
              <ButtonPrimary data-confirmation={YES} onClick={handleClick} contentKey={yesKey} />
            </StyledButtonContainer>
          </StyledContainer>
        </DialogCentreScreen>
      </MediaQuery>
    </React.Fragment>
  );
};
